import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { SelectUserModule } from '../select-user/select-user.module';
import { ModalHeaderComponentModule } from '../modal-header/modal-header.module';
import { SelectModalMultipleUserComponent } from './select-modal-multiple-user.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    SelectUserModule,
    ModalHeaderComponentModule,
  ],
  declarations: [SelectModalMultipleUserComponent],
  exports: [SelectModalMultipleUserComponent],
})
export class SelectModalMultipleUserModule { }
